<ng-container *ngIf="(gridColumns$ | async) && (gridOptions$ | async)">
  <app-grid
    *ngIf="(tableOfColumnItems | filterByProperty: 'tableOfColumnId' : tableOfColumnId).length ; else noTableOfColumnItems"
    [data]="gridData"
    [columns]="gridColumns$ | async"
    [options]="gridOptions$ | async"
  ></app-grid>

  <ng-template #noTableOfColumnItems>
    <div class="px-spacer-responsive py-3 border-top">
      <i i18n="@@dprDetails.dprTableOfColumnsRegistrationsGrid.txtNoActiveTablesOfColumnsEntries">
        You have no active entries. Go to Project Setup -> Tables of Columns in order to add or activate any.
      </i>
    </div>
  </ng-template>
</ng-container>

<ng-template #timeComponent let-context>
  <app-time [time]="context.selectedTime" (timeChanged)="context.timeChanged($event)"></app-time>
</ng-template>
